// src/pages/Landing.jsx
import React, { useState } from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import FeaturesSectionCompact from '../components/FeaturesSectionCompact';
import BenefitsSection from '../components/BenefitsSection';
import ComparisonSection from '../components/ComparisonSection';
import HowItWorksSection from '../components/HowItWorksSection';
import StructureCards from '../components/StructureCards';
import EarningsComparisonSection from '../components/EarningsComparisonSection';
import FAQSection from '../components/FAQSection';
import FinalCTASection from '../components/FinalCTASection';
import CadastroModal from '../components/CadastroModal';

// Firestore
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../services/firebase';

const Landing = () => {
  const [modalAberto, setModalAberto] = useState(false);

  const handleAbrirModal = () => {
    setModalAberto(true);
  };

  const handleFecharModal = () => {
    setModalAberto(false);
  };

  const handleEnviarCadastro = async (dados) => {
    try {
      // Salvar no Firestore
      await addDoc(collection(db, 'pre-cadastros'), {
        nome: dados.nome,
        email: dados.email,
        whatsapp: dados.whatsapp,
        tipo: dados.tipo,
        criadoEm: Timestamp.now(),
      });

      console.log('Pré-cadastro salvo com sucesso!');
      setModalAberto(false);

      // Redirecionar para página de confirmação da assinatura
      window.location.href = '/confirmar-assinatura';
    } catch (error) {
      console.error('Erro ao salvar pré-cadastro:', error);
      alert('Ocorreu um erro ao enviar seu cadastro. Tente novamente.');
    }
  };

  return (
    <div className="min-h-screen bg-elion-navy text-white">
      {/* Cabeçalho */}
      <Header />

      {/* Hero Section */}
      <HeroSection aoClicarBotao={handleAbrirModal} />

      {/* Features */}
      <FeaturesSectionCompact />

      {/* Benefícios */}
      <BenefitsSection />

      {/* Comparativo */}
      <ComparisonSection />

      {/* Como Funciona */}
      <HowItWorksSection />

      {/* Estrutura dos Corretores */}
      <StructureCards />

      {/* Comparativo de Ganhos */}
      <EarningsComparisonSection />

      {/* FAQ */}
      <FAQSection />

      {/* Galeria */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-white">
          Conheça Nossa Comunidade e Nossos Imóveis
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              src: '/imagens/imovel-1.jpg.jpeg',
              alt: 'Profissional de sucesso',
            },
            {
              src: '/imagens/rr.jpg',
              alt: 'Apartamento moderno',
            },
            {
              src: '/imagens/apartamento-moderno.jpg.jpeg',
              alt: 'Imóvel de destaque',
            },
            {
              src: '/imagens/imovel-2.jpg.jpeg',
              alt: 'Vitrine de vendas',
            },
          ].map((img, idx) => (
            <div
              key={idx}
              className="overflow-hidden rounded-lg shadow-lg hover:scale-105 transition"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-64 object-cover"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Chamada Final */}
      <FinalCTASection aoClicarBotao={handleAbrirModal} />

      {/* Modal de Cadastro */}
      <CadastroModal
        aberto={modalAberto}
        aoFechar={handleFecharModal}
        aoEnviar={handleEnviarCadastro}
      />

      {/* Rodapé */}
      <Footer />
    </div>
  );
};

export default Landing;
